import { LegalLayout, H2, H3 } from "./LegalLayout";

const Num = ({ n, children }) => (
  <p>
    <strong>{n}</strong> {children}
  </p>
);

export default function AGB() {
  return (
    <LegalLayout title="Allgemeine Geschäftsbedingungen (AGB)" testid="agb-page">
      <p className="text-slate-500">
        Allgemeine Geschäftsbedingungen mit Kundeninformationen &amp; Annex: Regelungen zum Anbieterwechsel
      </p>

      <H2>A. Allgemeine Geschäftsbedingungen mit Kundeninformationen</H2>

      <H3>§ 1 Geltungsbereich</H3>
      <Num n="1.1">
        Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") des Lucas Garrido, handelnd unter
        „Lucas Garrido" (nachfolgend „wir"), gelten für alle Verträge zur Erbringung von Dienstleistungen im
        Bereich Software-as-a-Service (nachfolgend „SaaS"), die du als Verbraucher oder Unternehmer (nachfolgend
        „Kunde") mit uns hinsichtlich der auf unserer Website beschriebenen Leistungen abschließt. Vertragsgegenstand
        ist dabei die entgeltliche, zeitlich auf die Vertragslaufzeit begrenzte Bereitstellung eines KI-Systems
        (nachfolgend „Software") in digitaler Form über das Internet sowie die Bereitstellung von Speicherplatz auf
        unseren Servern. Hiermit wird der Einbeziehung von eigenen Bedingungen des Kunden widersprochen, es sei denn,
        es ist etwas anderes vereinbart.
      </Num>
      <Num n="1.2">
        Verbraucher im Sinne dieser AGB bist du, wenn du ein Rechtsgeschäft zu Zwecken abschließt, die überwiegend
        weder deiner gewerblichen noch deiner selbstständigen beruflichen Tätigkeit zugerechnet werden können.
      </Num>
      <Num n="1.3">
        Unternehmer im Sinne dieser AGB bist du als natürliche oder juristische Person oder als rechtsfähige
        Personengesellschaft, die bei Abschluss eines Rechtsgeschäfts in Ausübung deiner gewerblichen oder
        selbstständigen beruflichen Tätigkeit handelt.
      </Num>
      <Num n="1.4">
        In unserer Software können Verknüpfungen zu Diensten von Drittanbietern enthalten sein. Diese AGB gelten nicht
        für solche Dienste, die nicht von uns, sondern von einem Drittanbieter erbracht werden. Dies gilt auch, wenn
        die Dienste unentgeltlich erbracht werden und/oder wenn für deren Nutzung eine Registrierung bei uns
        erforderlich ist. Für diese Dienste gelten ausschließlich die vom Drittanbieter verwendeten AGB bzw. die
        gesetzlichen Bestimmungen im Verhältnis zwischen dir und dem Drittanbieter. Wir vermitteln insoweit lediglich
        den technischen Zugriff auf diese Dienste.
      </Num>

      <H3>§ 2 Leistungen des Anbieters</H3>
      <Num n="2.1">
        Wir stellen dir für die Dauer der vereinbarten Vertragslaufzeit Software in digitaler Form über das Internet
        bereit. Hierzu ermöglichen wir dir den Zugang zu der Software, die auf unserem Server verbleibt. Der
        Funktionsumfang und die technischen Spezifikationen der Software werden in der Leistungsbeschreibung auf
        unserer Website näher beschrieben. Wir schulden lediglich die Bereitstellung der Software mit den in der
        Leistungsbeschreibung näher definierten Funktionalitäten. Wir schulden insbesondere nicht die Herstellung und
        Aufrechterhaltung der Datenverbindung zwischen deinem IT-System und unserem Server.
      </Num>
      <Num n="2.2">
        Wir schulden keinen Erfolg im Sinne einer bestimmten Qualität, inhaltlichen Richtigkeit, Vollständigkeit oder
        Verwertbarkeit der generierten Ergebnisse, da diese auf probabilistischen Modellen beruhen und von der
        Qualität, Vollständigkeit und Aktualität der von dir zur Verfügung gestellten Daten sowie der von unserer
        Software genutzten öffentlich zugänglichen Datenquellen abhängen. Insbesondere aufgrund der Funktionsweise
        probabilistischer KI-Modelle können trotz identischer Eingaben zu unterschiedlichen Zeitpunkten abweichende
        Ergebnisse generiert werden.
      </Num>
      <Num n="2.3">
        Sofern zwischen uns nichts anderes vereinbart ist, schulden wir keine Exklusivität der Ergebnisse. Wir weisen
        dich ausdrücklich darauf hin, dass Überschneidungen zwischen den für verschiedene Kunden generierten
        Ergebnissen möglich sind, da die Software auf Basis öffentlich zugänglicher Datenquellen arbeitet und mehrere
        Kunden vergleichbare Parameter definieren können.
      </Num>
      <Num n="2.4">
        Die mit der Software generierten Ergebnisse werden dir „wie besehen" („as is") zur Verfügung gestellt. Wir
        übernehmen keine Garantie hinsichtlich der inhaltlichen Richtigkeit, Vollständigkeit, Eignung oder
        Verwendbarkeit der generierten Ergebnisse, sofern zwischen uns nicht ausdrücklich etwas anderes vereinbart ist.
        Du bist verpflichtet, die generierten Ergebnisse eigenverantwortlich zu prüfen und deren Eignung für den
        vorgesehenen Zweck sicherzustellen.
      </Num>
      <Num n="2.5">
        Unsere Software ist nicht für den Einsatz als Hochrisiko-KI-System im Sinne der KI-Verordnung vorgesehen.
        Hierunter fallen KI-Systeme, die ein erhebliches Risiko für Gesundheit, Sicherheit oder Grundrechte bergen,
        beispielsweise Systeme zur biometrischen Identifizierung oder medizinische Diagnosesysteme. Du wirst die
        Software nicht in einer Art und Weise nutzen, die die Einordnung als Hochrisiko-KI-System rechtfertigt. Führt
        die Nutzung der Software durch dich zur Einordnung als Hochrisiko-KI-System, giltst du als Anbieter des
        KI-Systems im Sinne der KI-Verordnung.
      </Num>
      <Num n="2.6">
        Nach unserer Kenntnis ist die Software nicht verboten oder als Hochrisiko-KI-System im Sinne der KI-Verordnung
        einzustufen. Wir informieren dich unverzüglich über Änderungen der Risikoeinstufung der Software aufgrund der
        KI-Verordnung oder behördlicher Maßnahmen im Zusammenhang mit der KI-Verordnung und stellen dir ggf.
        erforderliche Informationen zur Verfügung. Nach unserer Kenntnis verletzt die Software bei bestimmungsgemäßer
        Nutzung ferner keine Rechte Dritter, insbesondere keine Schutzrechte. Werden wir von einer behaupteten
        Rechtsverletzung durch Dritte in Kenntnis gesetzt, informieren wir dich unverzüglich und werden nach eigenem
        billigen Ermessen
      </Num>
      <ul className="list-disc pl-6 space-y-1">
        <li>die beanstandete Funktionalität anpassen,</li>
        <li>eine Nutzungsberechtigung beschaffen oder</li>
        <li>die betroffene Funktionalität einstellen.</li>
      </ul>
      <Num n="2.7">
        Wir haben die Software nach dem Stand der Technik auf Voreingenommenheit getestet und setzen angemessene
        Maßnahmen zur Minimierung von Voreingenommenheit ein. Wir übernehmen keine Gewähr für die vollständige
        Abwesenheit von Voreingenommenheit. Erlangen wir Kenntnis von einer wesentlichen Voreingenommenheit, werden wir
        wirtschaftlich zumutbare Maßnahmen zur Korrektur ergreifen. Eine Voreingenommenheit ist wesentlich, wenn sie zu
        systematisch diskriminierenden Ergebnissen führt, die gegen geltendes Recht verstoßen oder den Vertragszweck
        gefährden. Eine vorübergehende Voreingenommenheit stellt keine Pflichtverletzung unsererseits dar, wenn wir alle
        erforderlichen und uns wirtschaftlich zumutbaren Maßnahmen zur Korrektur der Voreingenommenheit ergriffen haben.
        Sollte es uns in wirtschaftlich zumutbarem Umfang nicht möglich sein, die Unvoreingenommenheit der Software
        wiederherzustellen, sind wir beide zur vorzeitigen Beendigung des Vertragsverhältnisses berechtigt. Etwaige von
        dir im Voraus getätigte Zahlungen werden im Falle der vorzeitigen Vertragsbeendigung anteilig zurückerstattet.
      </Num>
      <Num n="2.8">
        Wir sind berechtigt, im Rahmen der Leistungserbringung KI-Modelle und -Systeme von Drittanbietern einzusetzen.
        Wir stellen sicher, dass die Drittanbieter vertraglich zur Einhaltung der datenschutzrechtlichen Anforderungen
        verpflichtet sind. Eine Übermittlung deiner personenbezogenen Daten an Drittanbieter außerhalb der EU/des EWR
        erfolgt nur unter Einhaltung der gesetzlichen Voraussetzungen.
      </Num>
      <Num n="2.9">
        Wir verpflichten uns, dir unverzüglich, nachdem wir davon Kenntnis erlangt haben, alle wesentlichen Vorfälle
        oder Entwicklungen mitzuteilen, die auf rechtswidrige Vorgänge im Zusammenhang mit der Software hindeuten oder
        die für die Zuverlässigkeit, Sicherheit oder Konformität der Software von Bedeutung sein könnten.
      </Num>
      <Num n="2.10">
        Unsere Software wird von uns in unregelmäßigen Abständen aktualisiert. Du erhältst dementsprechend nur ein
        Nutzungsrecht an der Software in der jeweils aktuellen Fassung. Du hast dagegen keinen Anspruch auf
        Herbeiführung eines bestimmten Zustandes der Software.
      </Num>
      <Num n="2.11">
        Wir stellen dir für die Nutzung der Software einen begrenzten Speicherplatz auf unseren Servern bereit. Der
        Umfang des Speicherplatzes wird in der Leistungsbeschreibung auf unserer Website näher beschrieben.
      </Num>
      <Num n="2.12">
        Die Leistungen des Anbieters werden unter dem Vorbehalt der Verfügbarkeit angeboten. Eine Verfügbarkeit zu 100
        Prozent ist technisch nicht zu realisieren und kann deshalb dem Kunden vom Anbieter nicht gewährleistet werden.
        Der Anbieter bemüht sich jedoch, den Dienst möglichst konstant verfügbar zu halten. Insbesondere Wartungs-,
        Sicherheits- oder Kapazitätsbelange sowie Ereignisse, die nicht im Machtbereich des Anbieters stehen
        (Störungen von öffentlichen Kommunikationsnetzen, Stromausfälle etc.), können zu Störungen oder zur
        vorübergehenden Stilllegung des Dienstes führen.
      </Num>
      <Num n="2.13">
        Wir treffen dem Stand der Technik entsprechende Maßnahmen zur Datensicherung. Eine Verwahrungs- oder
        Obhutspflicht trifft uns jedoch nicht. Du bist für eine ausreichende Datensicherung selbst verantwortlich.
      </Num>
      <Num n="2.14">Wir stellen dir eine Bedienungsanleitung in elektronischer Form zur Verfügung.</Num>
      <Num n="2.15">
        Wir bieten zusätzliche Support-Leistungen an. Inhalt und Umfang der Support-Leistungen ergeben sich aus der
        Leistungsbeschreibung auf unserer Website.
      </Num>

      <H3>§ 3 Leistungsänderungen</H3>
      <Num n="3.1">
        Wir behalten uns vor, die von uns angebotenen Leistungen zu ändern oder abweichende Leistungen anzubieten, es
        sei denn, dies ist für dich nicht zumutbar.
      </Num>
      <Num n="3.2">
        Wir behalten uns darüber hinaus vor, die von uns angebotenen Leistungen zu ändern oder abweichende Leistungen
        anzubieten,
      </Num>
      <ul className="list-disc pl-6 space-y-1">
        <li>soweit wir hierzu aufgrund einer Änderung der Rechtslage verpflichtet sind;</li>
        <li>soweit wir damit einem gegen uns gerichteten Gerichtsurteil oder einer behördlichen Entscheidung nachkommen;</li>
        <li>soweit die jeweilige Änderung notwendig ist, um bestehende Sicherheitslücken zu schließen;</li>
        <li>wenn die Änderung lediglich vorteilhaft für dich ist; oder</li>
        <li>wenn die Änderung rein technischer oder prozessualer Natur ohne wesentliche Auswirkungen für dich ist.</li>
      </ul>
      <Num n="3.3">
        Änderungen mit lediglich unwesentlichem Einfluss auf unsere Leistungen stellen keine Leistungsänderungen im
        Sinne dieser Ziffer dar. Dies gilt insbesondere für Änderungen rein graphischer Art und die bloße Änderung der
        Anordnung von Funktionen.
      </Num>

      <H3>§ 4 Vertragsschluss</H3>
      <Num n="4.1">
        Die auf unserer Website beschriebenen Leistungen stellen keine verbindlichen Angebote unsererseits dar, sondern
        dienen zur Abgabe eines verbindlichen Angebots durch dich.
      </Num>
      <Num n="4.2">
        Du kannst das Angebot über das auf unserer Website bereitgestellte Online-Bestellformular abgeben. Dabei gibst
        du nach Eingabe deiner persönlichen Daten durch Klicken des den Bestellvorgang abschließenden Buttons ein
        rechtlich verbindliches Vertragsangebot in Bezug auf die ausgewählten Leistungen ab.
      </Num>
      <Num n="4.3">Wir können dein Angebot innerhalb von fünf Tagen annehmen,</Num>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          indem wir dir eine schriftliche Auftragsbestätigung oder eine Auftragsbestätigung in Textform (Fax oder
          E-Mail) übermitteln, wobei insoweit der Zugang der Auftragsbestätigung bei dir maßgeblich ist, oder
        </li>
        <li>indem wir dich nach Abgabe deiner Bestellung zur Zahlung auffordern.</li>
      </ul>
      <p>
        Liegen mehrere der vorgenannten Alternativen vor, kommt der Vertrag in dem Zeitpunkt zustande, in dem eine der
        vorgenannten Alternativen zuerst eintritt. Die Frist zur Annahme des Angebots beginnt am Tag nach der Absendung
        des Angebots durch dich zu laufen und endet mit dem Ablauf des fünften Tages, welcher auf die Absendung des
        Angebots folgt. Wenn wir dein Angebot innerhalb vorgenannter Frist nicht annehmen, gilt dies als Ablehnung des
        Angebots mit der Folge, dass du nicht mehr an deine Willenserklärung gebunden bist.
      </p>
      <Num n="4.4">
        Bei Auswahl einer von PayPal angebotenen Zahlungsart erfolgt die Zahlungsabwicklung über den
        Zahlungsdienstleister PayPal (Europe) S.à r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxemburg (im
        Folgenden: „PayPal"), unter Geltung der PayPal-Nutzungsbedingungen. Zahlst du mittels einer im
        Online-Bestellvorgang auswählbaren von PayPal angebotenen Zahlungsart, erklären wir schon jetzt die Annahme
        deines Angebots in dem Zeitpunkt, in dem du den Button anklickst, welcher den Bestellvorgang abschließt.
      </Num>
      <Num n="4.5">
        Bei der Abgabe eines Angebots über unser Online-Bestellformular wird der Vertragstext nach dem Vertragsschluss
        von uns gespeichert und dir nach Absendung deiner Bestellung in Textform (z. B. E-Mail, Fax oder Brief)
        übermittelt. Eine darüber hinausgehende Zugänglichmachung des Vertragstextes durch uns erfolgt nicht.
      </Num>
      <Num n="4.6">
        Vor verbindlicher Abgabe der Bestellung über unser Online-Bestellformular kannst du mögliche Eingabefehler durch
        aufmerksames Lesen der auf dem Bildschirm dargestellten Informationen erkennen. Ein wirksames technisches Mittel
        zur besseren Erkennung von Eingabefehlern kann dabei die Vergrößerungsfunktion deines Browsers sein, mit deren
        Hilfe die Darstellung auf dem Bildschirm vergrößert wird. Deine Eingaben kannst du im Rahmen des elektronischen
        Bestellprozesses so lange über die üblichen Tastatur- und Mausfunktionen korrigieren, bis du den Button
        anklickst, welcher den Bestellvorgang abschließt.
      </Num>
      <Num n="4.7">Für den Vertragsschluss steht dir die deutsche Sprache zur Verfügung.</Num>
      <Num n="4.8">
        Die Bestellabwicklung und Kontaktaufnahme finden in der Regel per E-Mail und automatisierter Bestellabwicklung
        statt. Du hast sicherzustellen, dass die von dir zur Bestellabwicklung angegebene E-Mail-Adresse zutreffend ist,
        so dass die von uns versandten E-Mails unter dieser Adresse empfangen werden können. Insbesondere hast du bei
        dem Einsatz von SPAM-Filtern sicherzustellen, dass alle von uns oder von uns mit der Bestellabwicklung
        beauftragten Dritten versandten E-Mails zugestellt werden können.
      </Num>

      <H3>§ 5 Widerrufsrecht</H3>
      <p>
        Verbrauchern steht grundsätzlich ein Widerrufsrecht zu. Nähere Informationen zum Widerrufsrecht ergeben sich aus
        unserer Widerrufsbelehrung.
      </p>

      <H3>§ 6 Einräumung von Nutzungsrechten durch den Anbieter</H3>
      <Num n="6.1">
        Wir sind Inhaber sämtlicher Nutzungsrechte, die zur Bereitstellung der Software erforderlich sind. Sofern sich
        aus der Leistungsbeschreibung auf unserer Website nichts anderes ergibt, räumen wir dir an der Software das nicht
        ausschließliche, nicht übertragbare, zeitlich auf die Dauer des Vertrages beschränkte Recht ein, die Software zu
        privaten Zwecken im Rahmen dieser AGB zu nutzen. Eine darüber hinausgehende Nutzung der Software ist nicht
        gestattet.
      </Num>
      <Num n="6.2">
        Sämtliche Rechte, einschließlich aller geistigen Eigentumsrechte, an der Software, ihren Komponenten, Updates und
        Trainingsdaten verbleiben ausschließlich bei uns bzw. unseren Lizenzgebern, Lieferanten oder Subunternehmern.
      </Num>
      <Num n="6.3">
        Du bist nicht berechtigt, die Software zu trainieren, zu verändern, zu dekompilieren oder in sonstiger Weise zu
        modifizieren, soweit dir nicht das Gesetz entsprechende Nutzungsrechte zugesteht. Verstößt du gegen dieses
        Verbot, haften wir nicht für daraus resultierende Mängel. Du trägst die Beweislast dafür, dass ein Mangel nicht
        auf das unzulässige Training, die Veränderung oder Modifikation zurückzuführen ist. Weitergehende Ansprüche
        unsererseits bleiben unberührt.
      </Num>
      <Num n="6.4">
        Wir weisen dich darauf hin, dass an den durch die Nutzung der Software generierten Ergebnissen regelmäßig keine
        Schutzrechte, insbesondere keine Urheberrechte, entstehen. Soweit an den generierten Ergebnissen dennoch Rechte
        entstehen, übertragen wir dir ein einfaches Nutzungsrecht an den generierten Ergebnissen entsprechend den
        vorstehenden Bestimmungen zur Einräumung von Nutzungsrechten durch uns. Du darfst die generierten Ergebnisse
        auch an Dritte weitergeben.
      </Num>
      <Num n="6.5">
        Wir werden weder anonymisierte und aggregierte Nutzungsdaten noch die durch deine Nutzung der Software
        generierten Ergebnisse zur Weiterentwicklung und zum Training der KI-Modelle verwenden. Dies gilt auch für
        personenbezogene Daten oder individuell zuordenbare Kundendaten.
      </Num>

      <H3>§ 7 Einräumung von Nutzungsrechten durch den Kunden</H3>
      <Num n="7.1">
        Du räumst uns für die Dauer der Vertragslaufzeit ein einfaches, nicht ausschließliches, weltweites und
        unentgeltliches Nutzungsrecht an den von dir im Rahmen der Vertragserfüllung bereitgestellten Inhalten und
        Informationen (nachfolgend „Kundendaten") ein, soweit dies zur ordnungsgemäßen Erbringung unserer vertraglichen
        Leistungen oder zur Überwachung, Wartung und Verbesserung der Software erforderlich ist. Das Nutzungsrecht
        umfasst insbesondere das Recht zur Speicherung, Vervielfältigung, Bearbeitung und Nutzung der Kundendaten im
        Rahmen des vertraglich vereinbarten Zwecks. Eine Weitergabe deiner Kundendaten erfolgt nur, soweit dies aufgrund
        gesetzlicher Vorschriften oder vollstreckbarer behördlicher oder gerichtlicher Anordnungen erforderlich ist.
      </Num>
      <Num n="7.2">
        Du bist allein verantwortlich für die Rechtmäßigkeit, Richtigkeit und Vollständigkeit der von dir
        bereitgestellten Kundendaten. Du gewährleistest, dass du über alle erforderlichen Rechte, Zustimmungen und
        Genehmigungen zur Übermittlung und Nutzung der Kundendaten verfügst und durch die Nutzung der Kundendaten durch
        uns keine Rechte Dritter, insbesondere keine Rechte an geistigem Eigentum, Persönlichkeitsrechte oder
        Datenschutzrechte, verletzt werden. Wir sind nicht verpflichtet, die von dir bereitgestellten Kundendaten auf
        ihre Zulässigkeit, Rechtmäßigkeit oder Freiheit von Rechten Dritter zu prüfen.
      </Num>

      <H3>§ 8 Pflichten des Kunden</H3>
      <Num n="8.1">
        Du trägst dafür Sorge, dass die von dir eingesetzte Hard- und Software, einschließlich Arbeitsplatzrechnern,
        Routern, Datenkommunikationsmitteln etc., den technischen Mindestanforderungen an die Nutzung der aktuell von
        uns angebotenen Software-Version entspricht.
      </Num>
      <Num n="8.2">
        Du bist verpflichtet, die dir zur Verfügung gestellten Zugangsdaten nach dem Stand der Technik vor dem Zugriff
        Dritter zu schützen und zu verwahren. Du stellst sicher, dass eine Nutzung nur im vertraglich vereinbarten
        Umfang erfolgt. Unbefugte Zugriffe Dritter sind uns unverzüglich mitzuteilen.
      </Num>
      <Num n="8.3">
        Du darfst auf dem von uns zur Verfügung gestellten Speicherplatz keine Daten ablegen, deren Nutzung gegen
        geltendes Recht, behördliche Auflagen bzw. Anordnungen, Rechte Dritter oder Vereinbarungen mit Dritten verstößt.
      </Num>
      <Num n="8.4">
        Die von dir auf dem für dich bestimmten Speicherplatz abgelegten Inhalte können datenschutzrechtlich geschützt
        sein. Du prüfst in eigener Verantwortung, ob die Nutzung personenbezogener Daten durch dich datenschutzrechtlichen
        Anforderungen genügt.
      </Num>
      <Num n="8.5">Du hast in eigener Verantwortung regelmäßig angemessene Datensicherungen vorzunehmen.</Num>
      <Num n="8.6">
        Du bist verpflichtet, deine Daten und Informationen vor der Eingabe auf Viren oder sonstige schädliche
        Komponenten zu prüfen und hierzu dem Stand der Technik entsprechende Maßnahmen (z. B. Virenschutzprogramme)
        einzusetzen.
      </Num>
      <Num n="8.7">
        Du trägst dafür Sorge, dass von dir installierte Programme, Skripte o. ä. den Betrieb des Servers oder des
        Kommunikationsnetzes von uns oder die Sicherheit und Integrität anderer auf unseren Servern abgelegter Daten
        nicht gefährden.
      </Num>
      <Num n="8.8">
        Gefährden oder beeinträchtigen von dir installierte Programme, Skripte o. ä. den Betrieb unseres Servers oder
        unseres Kommunikationsnetzes oder die Sicherheit und Integrität anderer auf unseren Servern abgelegter Daten, so
        können wir diese Programme, Skripte etc. deaktivieren oder deinstallieren. Falls die Beseitigung der Gefährdung
        oder Beeinträchtigung dies erfordert, sind wir auch berechtigt, die Anbindung der auf dem Server abgelegten
        Inhalte an das Internet zu unterbrechen. Wir werden dich über diese Maßnahme unverzüglich informieren.
      </Num>
      <Num n="8.9">
        Du darfst die Software nicht für Praktiken nutzen, die nach der KI-Verordnung verboten sind. Hierunter fallen
        KI-Systeme, die als klare Bedrohung für Grundrechte oder Sicherheit gelten, beispielsweise manipulative oder
        diskriminierende KI.
      </Num>
      <Num n="8.10">
        Du darfst die Software nicht für automatisierte Entscheidungen einsetzen und die durch die Software generierten
        Ergebnisse nicht ohne eine vorherige menschliche Überprüfung verwenden, sofern dies erhebliche rechtliche oder
        wirtschaftliche Auswirkungen auf Dritte haben kann.
      </Num>
      <Num n="8.11">
        Die für dich generierten Ergebnisse können aufgrund automatisierter Datenverarbeitung personenbezogene Daten
        enthalten, auch wenn du diese nicht eingegeben hast. Du bist verpflichtet, die generierten Ergebnisse vor der
        Nutzung außerhalb der Software eigenverantwortlich auf personenbezogene Daten oder Geschäftsgeheimnisse Dritter
        sowie auf die für die Verwendung dieser Daten erforderliche Rechtsgrundlage zu prüfen. Im Übrigen bist du
        verpflichtet, keine personenbezogenen Daten oder Geschäftsgeheimnisse Dritter in unsere Software einzugeben,
        soweit dies nicht für den vertraglich vereinbarten Nutzungszweck zwingend erforderlich und du zur Verarbeitung
        dieser Daten berechtigt bist.
      </Num>
      <Num n="8.12">
        Du bist als Betreiber im Sinne der KI-Verordnung verpflichtet, die für dich geltenden Pflichten, insbesondere
        die jeweiligen geltenden gesetzlichen Kennzeichnungspflichten für KI-generierte Inhalte bei der Weiterverwendung
        der generierten Ergebnisse sowie die Informationspflichten gegenüber betroffenen Personen, einzuhalten. Wir
        stellen dir auf Verlangen die für die Erfüllung dieser Pflichten erforderlichen Informationen zur Verfügung.
      </Num>
      <Num n="8.13">
        Dir ist bewusst, dass unsere Software in Ausnahmefällen aufgrund der Funktionsweise von KI-Modellen fehlerhafte
        oder unvollständige Ergebnisse liefern kann (sog. „Halluzinationen"). Du verpflichtest dich, die von der Software
        generierten Ergebnisse vor ihrer Weiterverwendung auf Plausibilität und Richtigkeit zu überprüfen.
      </Num>
      <Num n="8.14">
        Erlangst du Kenntnis von tatsächlichen oder potenziellen Umständen, die geeignet sind, die Sicherheit der
        Software zu beeinträchtigen, Schäden zu verursachen oder die auf eine Mangelhaftigkeit der Software bzw. ihrer
        generierten Ergebnisse hinweisen, bist du verpflichtet, uns unverzüglich über diese Umstände zu informieren. Du
        hast uns alle Informationen und zumutbare Unterstützung bereitzustellen, die nach billigem Ermessen zur
        Aufklärung, Minderung oder Beseitigung solcher Umstände erforderlich sind. Zu den meldepflichtigen Umständen
        zählen insbesondere:
      </Num>
      <ul className="list-disc pl-6 space-y-1">
        <li>unbefugte Nutzung oder unbefugter Zugriff auf deine Systeme,</li>
        <li>
          behördliche oder gerichtliche Maßnahmen und Entscheidungen, die sich auf deine Nutzung der Software auswirken
          und die Bereitstellung der Software beeinträchtigen können,
        </li>
        <li>Hinweise auf Voreingenommenheit (sog. „Bias") oder Halluzinationen der Software.</li>
      </ul>

      <H3>§ 9 Moderation und Beschränkung von Inhalten</H3>
      <Num n="9.1">
        Wir sind grundsätzlich nicht verpflichtet, die von dir eingestellten Inhalte proaktiv auf ihre Rechtmäßigkeit
        oder Vereinbarkeit mit den Rechten Dritter oder diesen AGB zu überprüfen. Wir behalten uns gleichwohl vor, im
        Einzelfall auf eigene Veranlassung Inhalte von dir auf deren Rechtmäßigkeit hin zu überprüfen und im Falle von
        festgestellten Verstößen Maßnahmen gemäß nachfolgender Bestimmungen zu ergreifen.
      </Num>
      <Num n="9.2">
        Kunden und betroffene Dritte können uns mutmaßlich rechtswidrige Inhalte unter Nutzung der Kontaktinformationen
        im Impressum (z. B. per E-Mail) melden. Es steht uns frei, den Inhalt einer Meldung an dich, wenn du den
        gemeldeten Inhalt eingestellt hast, weiterzuleiten. Die Identität der meldenden Person wird dir nur dann
        offengelegt, wenn dies unbedingt notwendig ist.
      </Num>
      <Num n="9.3">
        Im Falle von Meldungen und im Rahmen von gegebenenfalls auf unsere Eigeninitiative durchgeführten Überprüfungen
        erfolgt grundsätzlich eine menschliche Inhaltskontrolle. In Einzelfällen können automatisierte technische
        Prüfungsverfahren ergänzend hinzugezogen werden.
      </Num>
      <Num n="9.4">
        Wird auf eine Meldung hin oder im Rahmen einer Prüfung auf unsere Eigeninitiative die Rechtswidrigkeit eines von
        dir veröffentlichten Inhalts festgestellt, sind wir berechtigt, auch ohne vorherige Ankündigung oder
        Kontaktaufnahme nach billigem Ermessen eine oder mehrere der folgenden Maßnahmen zu ergreifen:
      </Num>
      <ul className="list-disc pl-6 space-y-1">
        <li>Verwarnung von dir als veröffentlichendem Kunden,</li>
        <li>vorübergehende Sperrung oder dauerhafte Löschung des betroffenen Inhalts,</li>
        <li>vorübergehende oder dauerhafte Aussetzung der vertraglich übernommenen Pflichten,</li>
        <li>Kündigung der Vertragsbeziehung (ordentlich oder außerordentlich aus wichtigem Grund).</li>
      </ul>
      <Num n="9.5">
        Bei der Wahl der zu treffenden Maßnahmen werden wir die Grundsätze der Verhältnismäßigkeit berücksichtigen und
        deine Interessen als betroffener Kunde mit unseren eigenen Interessen an der ungehinderten, störungsfreien und
        integren Fortführung unserer Geschäftstätigkeit abwägen.
      </Num>
      <Num n="9.6">
        Sofern du häufig offensichtlich unbegründete Meldungen oder Beschwerden einreichst, setzen wir die Bearbeitung
        von Meldungen und Beschwerden deinerseits nach vorheriger Warnung für einen angemessenen Zeitraum aus.
      </Num>

      <H3>§ 10 Vergütung und Zahlungsbedingungen</H3>
      <Num n="10.1">
        Sofern sich aus unserer Leistungsbeschreibung nichts anderes ergibt, handelt es sich bei den angegebenen Preisen
        um Gesamtpreise, die die gesetzliche Umsatzsteuer enthalten.
      </Num>
      <Num n="10.2">
        Die Zahlungsmöglichkeiten und die Zahlungsmodalitäten werden dir auf unserer Website mitgeteilt.
      </Num>
      <Num n="10.3">
        Die Vergütung wird von uns für den vereinbarten Leistungszeitraum im Voraus abgerechnet und kann von dir per
        Banküberweisung auf unser angegebenes Bankkonto gezahlt werden. Sofern sich aus dem Inhalt der Rechnung nichts
        anderes ergibt, ist der Rechnungsbetrag sofort zur Zahlung fällig.
      </Num>
      <Num n="10.4">
        Bei Auswahl einer über den Zahlungsdienst „PayPal" angebotenen Zahlungsart erfolgt die Zahlungsabwicklung über
        PayPal, wobei sich PayPal hierzu auch der Dienste dritter Zahlungsdienstleister bedienen kann.
      </Num>
      <Num n="10.5">
        Bei Auswahl einer über den Zahlungsdienst „Stripe" angebotenen Zahlungsart erfolgt die Zahlungsabwicklung über
        den Zahlungsdienstleister Stripe Payments Europe Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin,
        Irland. Weitere Informationen zu Stripe sind im Internet unter https://stripe.com/de abrufbar.
      </Num>

      <H3>§ 11 Vertragsdauer und Vertragsbeendigung</H3>
      <Num n="11.1">
        Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt. Ein wichtiger Grund liegt vor,
        wenn dem kündigenden Teil unter Berücksichtigung aller Umstände des Einzelfalls und unter Abwägung der
        beiderseitigen Interessen die Fortsetzung des Vertragsverhältnisses bis zur vereinbarten Beendigung oder bis zum
        Ablauf einer Kündigungsfrist nicht zugemutet werden kann.
      </Num>
      <Num n="11.2">Kündigungen haben schriftlich oder in Textform (z. B. per E-Mail) zu erfolgen.</Num>
      <Num n="11.3">
        Mit der Vertragsbeendigung verlierst du den Zugriff auf dein Nutzerkonto. Ferner erlischt mit der
        Vertragsbeendigung auch unsere Pflicht zur Speicherung von deinen eingestellten Daten.
      </Num>

      <H3>§ 12 Mängelhaftung</H3>
      <Num n="12.1">Handelst du als Verbraucher, so gelten die Vorschriften der gesetzlichen Mängelhaftung.</Num>
      <Num n="12.2">
        Handelst du als Unternehmer, so gelten die Vorschriften der gesetzlichen Mängelhaftung unter Berücksichtigung
        der nachfolgenden Einschränkungen: Du musst uns auftretende Mängel, Störungen oder Schäden unverzüglich
        anzeigen. Wir schließen die Gewährleistung für nur unerhebliche Minderungen der Tauglichkeit der Leistung aus.
        Unsere verschuldensunabhängige Haftung gemäß § 536a Abs. 1 BGB für Mängel, die bereits bei Vertragsschluss
        vorlagen, ist ausgeschlossen. Eine Kündigung von dir wegen Nichtgewährung des vertragsgemäßen Gebrauchs ist erst
        zulässig, wenn wir ausreichende Gelegenheit zur Mängelbeseitigung hatten und diese fehlgeschlagen ist.
      </Num>

      <H3>§ 13 Haftung</H3>
      <p>
        Wir haften dir aus allen vertraglichen, vertragsähnlichen und gesetzlichen, auch deliktischen Ansprüchen auf
        Schadens- und Aufwendungsersatz wie folgt:
      </p>
      <Num n="13.1">Wir haften aus jedem Rechtsgrund uneingeschränkt</Num>
      <ul className="list-disc pl-6 space-y-1">
        <li>bei Vorsatz oder grober Fahrlässigkeit,</li>
        <li>bei vorsätzlicher oder fahrlässiger Verletzung des Lebens, des Körpers oder der Gesundheit,</li>
        <li>aufgrund eines Garantieversprechens, soweit diesbezüglich nichts anderes geregelt ist,</li>
        <li>aufgrund zwingender Haftung wie etwa nach dem Produkthaftungsgesetz.</li>
      </ul>
      <Num n="13.2">
        Handelst du als Verbraucher mit Sitz in Deutschland oder als Unternehmer, gelten folgende
        Haftungsbeschränkungen: Verletzen wir fahrlässig eine wesentliche Vertragspflicht, ist unsere Haftung auf den
        vertragstypischen, vorhersehbaren Schaden begrenzt, sofern wir nicht gemäß vorstehender Ziffer unbeschränkt
        haften. Wesentliche Vertragspflichten sind Pflichten, die der Vertrag uns nach seinem Inhalt zur Erreichung des
        Vertragszwecks auferlegt, deren Erfüllung die ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht
        und auf deren Einhaltung du regelmäßig vertrauen darfst. Im Übrigen ist eine Haftung unsererseits ausgeschlossen,
        sofern wir nicht gemäß vorstehender Ziffer unbeschränkt haften.
      </Num>
      <Num n="13.3">
        Vorstehende Haftungsregelungen gelten auch im Hinblick auf unsere Haftung für unsere Erfüllungsgehilfen und
        gesetzlichen Vertreter.
      </Num>

      <H3>§ 14 Haftungsfreistellung</H3>
      <p>
        Du stellst uns von sämtlichen Ansprüchen frei, die andere Kunden oder sonstige Dritte uns gegenüber wegen
        Verletzung ihrer Rechte aufgrund von dir eingestellter Inhalte oder wegen deiner sonstigen Nutzung geltend
        machen. Du übernimmst hierbei auch die notwendigen Kosten der Rechtsverteidigung einschließlich aller Gerichts-
        und Anwaltskosten in gesetzlicher Höhe. Dies gilt nicht, wenn du die Rechtsverletzung nicht zu vertreten hast.
        Du bist verpflichtet, uns im Falle einer Inanspruchnahme durch Dritte unverzüglich, wahrheitsgemäß und
        vollständig alle Informationen zur Verfügung zu stellen, die für die Prüfung der Ansprüche und eine Verteidigung
        erforderlich sind.
      </p>

      <H3>§ 15 Höhere Gewalt</H3>
      <p>
        Wird unsere Leistungserbringung infolge höherer Gewalt (z. B. Naturkatastrophen, Pandemien, behördliche oder
        gerichtliche Anordnungen, Krieg, Streik, Blockaden, Embargo, flächendeckende und von keiner Partei zu
        vertretende Störungen der Internet-Infrastruktur, Ausfall oder Einschränkung von Drittanbieter-KI-Modellen,
        behördliche Untersagung des KI-Einsatzes, sowie unvorhersehbare regulatorische Änderungen, die den Betrieb der
        Software unmöglich machen) erheblich erschwert, gefährdet oder unmöglich, können wir beide den Vertrag fristlos
        kündigen. Die bereits gezahlte Vergütung für nicht erbrachte Leistungen wird dir erstattet. Gegebenenfalls
        bestehende Schadensersatzansprüche bleiben hiervon unberührt.
      </p>

      <H3>§ 16 Geheimhaltung</H3>
      <p>
        Wir verpflichten uns, über alle vertraulichen Informationen, von denen wir im Zusammenhang mit diesem Vertrag
        und dessen Durchführung Kenntnis erlangen, Stillschweigen zu bewahren und diese nicht gegenüber Dritten
        offenzulegen. Die Geheimhaltungsverpflichtung gilt nicht, soweit wir gesetzlich oder aufgrund bestands- bzw.
        rechtskräftiger Behörden- oder Gerichtsentscheidung zur Offenlegung der vertraulichen Information verpflichtet
        sind.
      </p>

      <H3>§ 17 Änderung der AGB</H3>
      <Num n="17.1">
        Wir behalten uns vor, diese AGB jederzeit zu ändern, sofern du der Änderung zustimmst.
      </Num>
      <Num n="17.2">
        Wir behalten uns darüber hinaus vor, diese AGB auch ohne deine Zustimmung zu ändern,
      </Num>
      <ul className="list-disc pl-6 space-y-1">
        <li>soweit wir hierzu aufgrund einer Änderung der Rechtslage verpflichtet sind;</li>
        <li>soweit wir damit einem gegen uns gerichteten Gerichtsurteil oder einer behördlichen Entscheidung nachkommen;</li>
        <li>
          soweit wir zusätzliche, gänzlich neue Dienstleistungen, Dienste oder Dienstelemente einführen, die einer
          Leistungsbeschreibung in den AGB bedürfen, es sei denn, das bisherige Nutzungsverhältnis wird dadurch
          nachteilig verändert;
        </li>
        <li>wenn die Änderung lediglich vorteilhaft für dich ist; oder</li>
        <li>wenn die Änderung rein technisch oder prozessual bedingt ist, es sei denn, sie hat wesentliche Auswirkungen für dich.</li>
      </ul>
      <Num n="17.3">
        Über wesentliche Änderungen dieser AGB werden wir dich rechtzeitig und in geeigneter Form informieren.
      </Num>
      <Num n="17.4">Dein Kündigungsrecht bleibt hiervon unberührt.</Num>

      <H3>§ 18 Anwendbares Recht, Gerichtsstand</H3>
      <p>
        Für sämtliche Rechtsbeziehungen zwischen uns gilt das Recht der Bundesrepublik Deutschland. Wenn du als
        Verbraucher handelst, gilt diese Rechtswahl nur insoweit, als dir nicht der durch zwingende Bestimmungen des
        Rechts des Staates, in dem du deinen gewöhnlichen Aufenthalt hast, gewährte Schutz entzogen wird.
      </p>

      <H3>§ 19 Alternative Streitbeilegung</H3>
      <p>
        Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle weder
        verpflichtet noch bereit.
      </p>

      <H2>B. Annex: Regelungen zum Anbieterwechsel</H2>
      <p>
        Die nachfolgenden Bestimmungen gelten für den Fall, dass du zu einem anderen Anbieter oder zu einer
        IKT-Infrastruktur in deinen eigenen Räumlichkeiten wechseln möchtest. Sie setzen die Vorgaben des EU Data Act
        um und regeln u. a. Begriffsbestimmungen, vorvertragliche Informationen, den Wechsel- und Ausstiegsplan, die
        Einleitung des Wechselprozesses, Übergangs- und Datenabruffristen, die Pflichten des Anbieters und die
        Obliegenheiten des Kunden, die Wiederherstellung und Löschung von Daten, die Vergütung (wir berechnen keine
        zusätzliche Vergütung für den Wechselprozess) sowie die Beendigung des Wechselprozesses und des Vertrags.
      </p>
      <p className="text-slate-500">
        Der vollständige Annex ist Bestandteil dieser AGB. Die Übergangsfrist beträgt 30 Kalendertage; die Frist für den
        Datenabruf beträgt 30 Kalendertage nach Ablauf der Übergangsfrist. Die Kündigungsfrist zur Einleitung des
        Wechselprozesses beträgt 2 Monate.
      </p>

      <p className="pt-6 text-slate-500">Stand: 29.07.2026</p>
    </LegalLayout>
  );
}
